import { render, staticRenderFns } from "./appoint-setting.vue?vue&type=template&id=5889f696&scoped=true"
import script from "./appoint-setting.vue?vue&type=script&lang=js"
export * from "./appoint-setting.vue?vue&type=script&lang=js"
import style0 from "./appoint-setting.vue?vue&type=style&index=0&id=5889f696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889f696",
  null
  
)

export default component.exports